import React, { useState } from "react";
import "../styles/global.css";
import { FaStar } from "react-icons/fa";

function Reviews() {
  // Initial sample reviews
  const [reviews, setReviews] = useState([
    {
      name: "Mohammed Shoaib",
      rating: 5,
      message: "Fantastic food and great service! Definitely coming back."
    },
    {
      name: "Mohammed Shifaad",
      rating: 4,
      message: "Loved the ambiance. Starters were super tasty!"
    },
    {
      name: "Mohammed Sabir",
      rating: 3,
      message: "Main course was okay, but desserts were outstanding."
    },
    {
      name: "Mohammed Akram",
      rating: 5,
      message: "Perfect place for family dinners. Paneer Tikka is a must try!"
    },
    {
      name: "Mohammed Suheel",
      rating: 5,
      message: "Perfect place for family dinners. Paneer Tikka is a must try!"
    },
    {
      name: "Datatreya",
      rating: 5,
      message: "Perfect place for family dinners. Paneer Tikka is a must try!"
    },
  ]);

  const [newReview, setNewReview] = useState({
    name: "",
    rating: 0,
    message: ""
  });

  const handleInput = (e) => {
    setNewReview({ ...newReview, [e.target.name]: e.target.value });
  };

  const handleStarClick = (rating) => {
    setNewReview({ ...newReview, rating });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newReview.name && newReview.rating > 0) {
      setReviews([newReview, ...reviews]);
      setNewReview({ name: "", rating: 0, message: "" });
    } else {
      alert("Please fill in name and rating!");
    }
  };

  return (
    <div className="reviews-container">
      <h1>Add Your Review</h1>

      {/* Add Review Form */}
      <form className="add-review-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={newReview.name}
          onChange={handleInput}
          required
        />

        <div className="star-selector">
          {[...Array(5)].map((_, i) => (
            <FaStar
              key={i}
              onClick={() => handleStarClick(i + 1)}
              color={i < newReview.rating ? "#f39c12" : "#ccc"}
              className="star"
            />
          ))}
        </div>

        <textarea
          name="message"
          placeholder="Your Review (optional)"
          rows="3"
          value={newReview.message}
          onChange={handleInput}
        ></textarea>

        <button type="submit">Submit Review</button>
      </form>

      {/* Review Cards */}
      <div className="reviews-grid">
        <h1>Customer Reviews</h1>
        <div className="reviews-center">
        {reviews.map((review, index) => (
            <div className="review-card" key={index}>
            <h3>{review.name}</h3>
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <FaStar
                key={i}
                color={i < review.rating ? "#f39c12" : "#ccc"}
                />
            ))}
            </div>
            {review.message && <p>"{review.message}"</p>}
          </div>
        ))}
        </div>
      </div>
    </div>
  );
}

export default Reviews;
